<nz-form-item>
    <nz-form-label>{{customField.name}}</nz-form-label>
    <nz-form-control>
        <input *ngIf="!customField.isMultiSelect" nz-input [(ngModel)]="value" [type]="customField.type" />
        <nz-select *ngIf="customField.isMultiSelect" [(ngModel)]="value" nzMode="tags" [nzTokenSeparators]="[',', ';']"></nz-select>
    </nz-form-control>
</nz-form-item>